const PROFILE_CACHE_KEY = 'user_profile_payload'

export function getCachedUserProfile() {
  const raw = localStorage.getItem(PROFILE_CACHE_KEY)
  if (!raw) {
    return null
  }
  try {
    return JSON.parse(raw)
  } catch (error) {
    localStorage.removeItem(PROFILE_CACHE_KEY)
    return null
  }
}

export function setCachedUserProfile(payload) {
  if (!payload || typeof payload !== 'object') {
    return
  }
  localStorage.setItem(PROFILE_CACHE_KEY, JSON.stringify(payload))
}

export function removeCachedUserProfile() {
  localStorage.removeItem(PROFILE_CACHE_KEY)
}

export function formatDateOnly(dateTime) {
  if (!dateTime) {
    return '--'
  }
  return String(dateTime).split(' ')[0] || '--'
}

export function calculateAge(birthday) {
  if (!birthday) {
    return '--'
  }
  const birth = new Date(birthday)
  if (Number.isNaN(birth.getTime())) {
    return '--'
  }
  const today = new Date()
  let age = today.getFullYear() - birth.getFullYear()
  const monthDiff = today.getMonth() - birth.getMonth()
  const dayDiff = today.getDate() - birth.getDate()
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age -= 1
  }
  return age >= 0 ? `${age}` : '--'
}

export function formatPartyAge(joinAt, referenceDate) {
  if (!joinAt) {
    return '--'
  }
  const joinDate = new Date(joinAt)
  const endDate = referenceDate ? new Date(referenceDate) : new Date()
  if (Number.isNaN(joinDate.getTime()) || Number.isNaN(endDate.getTime())) {
    return '--'
  }

  const safeEndDate = endDate < joinDate ? joinDate : endDate
  let totalMonths =
    (safeEndDate.getFullYear() - joinDate.getFullYear()) * 12 +
    (safeEndDate.getMonth() - joinDate.getMonth())

  if (safeEndDate.getDate() < joinDate.getDate()) {
    totalMonths -= 1
  }

  if (totalMonths < 0) {
    totalMonths = 0
  }

  const years = Math.floor(totalMonths / 12)
  const months = totalMonths % 12

  if (years <= 0) {
    return `${months}个月`
  }
  return `${years}年${months}个月`
}
